import Vue from 'vue'

const KyeCheckbox = Vue.component('kye-checkbox', {
  functional: true,
  render (h, self) {
    return h('el-checkbox', self.data, self.children)
  }
})

export default KyeCheckbox



// WEBPACK FOOTER //
// ./src/public/components/kye-checkbox/index.js